export default {


  login(data) {
    return env.API.post('/auth/login', data);
  },

  createUser(data) {
    return env.API.post('/auth/signup', data);
  },

  sendResetPasswordMail(email) {
    return env.API.post('/auth/', email);
  },

  sendMail(email) {
    return env.API.post('/auth/sendMail', {email});
  },
  
  forgot(token, newPassword) {
    return env.API.post('/auth/forgot', {token, newPassword});
  },

  loginWithTempToken(token) {
    return env.API.get('/auth/token/' + token);
  },
  sendRegSocialMail() {
    return env.API.get(`/auth/sendRegSocialMail`)
  }
}
